import { __read } from 'tslib';
import React, { useState, useRef, useEffect } from 'react';
import { Ioc } from '@baidu/bce-decorators/dist/index.js';
import { UDynamicService } from '@baidu/bce-services/dist/index.js';
import result from '../../utils/userinfo.js';
import { ajax } from '../../utils/ajax.js';
import { ULoginModal } from './Components/ULoginModal/index.js';
import { UActivateModal } from './Components/UActivateModal/index.js';
import { getEnv } from '../../utils/getEnv.js';
import Nav from './Components/Nav/index.js';
import cx from 'classnames';
import User from './Components/User/index.js';
import { Button } from 'acud';
import Capsule from '../../components/Capsule/index.js';
import { findConsoleHref as _findConsoleHref } from '../../utils/util.js';
import useIsMobile from '../../utils/hooks.js';

var env = getEnv();
var Header = function Header(props) {
  var logo = props.logo,
    menus = props.menus,
    _a = props.needLogin,
    needLogin = _a === void 0 ? true : _a,
    customBtn = props.customBtn,
    _b = props.env,
    _env = _b === void 0 ? env : _b;
  var loginUrl = "https://login.bce".concat(_env === 'SANDBOX' ? 'test' : '', ".baidu.com/");
  var _c = __read(useState({}), 2),
    userInfo = _c[0],
    setUserInfo = _c[1];
  var headerRef = useRef(null);
  var headerWrapperRef = useRef(null);
  var isMobile = useIsMobile();
  useEffect(function () {
    if (needLogin) {
      // 获取用户登录信息
      result.init(function (info) {
        info.hasLogin && setUserInfo(info);
      });
    }
    // 监听浏览器上下滚动
    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  useEffect(function () {
    if (!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.hasLogin) && needLogin && !isMobile) {
      document.addEventListener('click', clickHandler);
    }
    return function () {
      document.removeEventListener('click', clickHandler);
    };
  }, [isMobile, userInfo]);
  var clickHandler = function clickHandler(e) {
    var consoleHref = _findConsoleHref(e.target);
    if (consoleHref) {
      e.preventDefault();
      Ioc(UDynamicService).open({
        component: ULoginModal,
        props: {
          maskClosable: true,
          href: loginUrl,
          onOk: function onOk(info) {
            if (info.activateSuccess || info.regSuccess) {
              result.init(function () {
                location.href = consoleHref;
              }, false, true);
            } else {
              location.href = consoleHref;
            }
          }
        }
      });
    }
  };
  var handleScroll = function handleScroll() {
    if (!headerRef.current || !headerWrapperRef.current) return;
    var headerDom = headerRef.current;
    var headerWrapperDom = headerWrapperRef.current;
    var body = document.querySelector('body');
    // 弹窗登录框出现时，scrollTop为0；导致header位置不对
    if (body === null || body === void 0 ? void 0 : body.classList.contains('header-body-no-scroll')) {
      return;
    }
    var scrollTop = document.documentElement.scrollTop;
    if (scrollTop === 0) {
      headerDom.style.top = '0';
    } else {
      headerDom.style.top = '12px';
    }
    if (scrollTop > 10) {
      headerDom.classList.add('qf-header-fixed');
      headerWrapperDom.style.height = '0';
    } else {
      headerDom.classList.remove('qf-header-fixed');
      headerWrapperDom.style.height = '60px';
    }
  };
  // 登录
  var handleLogin = function handleLogin() {
    sign(loginUrl);
  };
  // 注册
  var handleRegister = function handleRegister() {
    var url = "https://login.bce".concat(_env === 'SANDBOX' ? 'test' : '', ".baidu.com/new-reg");
    sign(url);
  };
  var handleCustomClick = function handleCustomClick() {
    var _a = props.customBtn,
      link = _a.link,
      _b = _a.target,
      target = _b === void 0 ? '_blank' : _b;
    if (link) {
      window.open(link, target);
    }
  };
  var sign = function sign(url) {
    Ioc(UDynamicService).open({
      component: ULoginModal,
      props: {
        maskClosable: true,
        href: url,
        onOk: function onOk(info) {
          result.init(function () {
            if (info.activateSuccess || info.regSuccess) ; else {
              checkAccount();
            }
          }, false, true);
        },
        onCancel: function onCancel() {
          result.init(function (info) {
            info.hasLogin && checkAccount();
          }, false, true);
        }
      }
    });
  };
  var checkAccount = function checkAccount() {
    ajax({
      url: '/api/account/status',
      type: 'GET',
      dataType: 'json',
      contentType: 'application/json',
      success: function success(response) {
        try {
          if (typeof response === 'string') {
            response = JSON.parse(response);
          }
          if (response && response.success && response.result && response.result.code === 201) {
            // 未激活
            Ioc(UDynamicService).open({
              component: UActivateModal,
              props: {
                env: _env,
                maskClosable: false,
                onOk: function onOk() {}
              }
            });
          }
        } catch (e) {
          console.error('账号状态获取', e);
        }
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: headerWrapperRef,
    className: "no_rem-qf-header qf-header-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    ref: headerRef,
    className: "qf-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-left"
  }, /*#__PURE__*/React.createElement("div", {
    className: "logo-wrapper"
  }, /*#__PURE__*/React.createElement("a", {
    href: logo.link,
    target: logo.target || '_blank'
  }, /*#__PURE__*/React.createElement("img", {
    src: logo.url,
    className: cx(logo.className),
    alt: "logo"
  })))), /*#__PURE__*/React.createElement(Nav, {
    menus: menus,
    className: "header-nav-margin"
  }), /*#__PURE__*/React.createElement("div", {
    className: "header-right"
  }, needLogin ? (userInfo === null || userInfo === void 0 ? void 0 : userInfo.hasLogin) && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.displayName) ? (/*#__PURE__*/React.createElement(User, {
    uname: userInfo.displayName,
    menus: [{
      title: '退出',
      link: "https://login.bce".concat(_env === 'SANDBOX' ? 'test' : '', ".baidu.com/logout?redirect=").concat(window.location.href),
      target: '_self'
    }]
  })) : (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    type: "text",
    className: "login-btn",
    onClick: handleLogin,
    "data-track-name": "\u6309\u94AE\u70B9\u51FB",
    "data-track-value": "\u767B\u5F55",
    "data-track-category": "\u5934\u90E8\u5BFC\u822A"
  }, "\u767B\u5F55"), /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    className: "register-btn",
    onClick: handleRegister,
    "data-track-name": "\u6309\u94AE\u70B9\u51FB",
    "data-track-value": "\u6CE8\u518C",
    "data-track-category": "\u5934\u90E8\u5BFC\u822A"
  }, "\u6CE8\u518C"))) : (/*#__PURE__*/React.createElement(React.Fragment, null, (customBtn === null || customBtn === void 0 ? void 0 : customBtn.text) && (/*#__PURE__*/React.createElement(Button, {
    type: "primary",
    className: "register-btn",
    onClick: handleCustomClick,
    "data-track-name": "\u6309\u94AE\u70B9\u51FB",
    "data-track-value": customBtn === null || customBtn === void 0 ? void 0 : customBtn.text,
    "data-track-category": "\u5934\u90E8\u5BFC\u822A"
  }, customBtn === null || customBtn === void 0 ? void 0 : customBtn.text)))), /*#__PURE__*/React.createElement("div", {
    className: "header-capsule"
  }, /*#__PURE__*/React.createElement(Capsule, {
    env: _env
  })))));
};

export { Header as default };
